import {AxiosInstance, AxiosRequestConfig} from 'axios'

import {PlantHierarchy, PlantHierarchyNode, UpmPlant} from '../response'
import {StringParams} from '../types'

export const getUpmPlantsByCountry =
  (api: AxiosInstance) =>
  async (
    country: string,
    params: StringParams = {},
    axiosConfig?: AxiosRequestConfig
  ): Promise<UpmPlant[]> => {
    const config = {params, ...axiosConfig}
    const response = await api.get<UpmPlant[]>(`upm/plant?country=${country}`, config)
    return response.data
  }

export const getUpmPlantById =
  (api: AxiosInstance) =>
  async (
    upmId: string,
    params: StringParams = {},
    axiosConfig?: AxiosRequestConfig
  ): Promise<UpmPlant> => {
    const config = {params, ...axiosConfig}
    const response = await api.get<UpmPlant>(`upm/plant/${upmId}`, config)
    return response.data
  }

export const getUpmHierarchy =
  (api: AxiosInstance) =>
  async (
    permissionFilter: string,
    params: StringParams = {},
    axiosConfig?: AxiosRequestConfig
  ): Promise<PlantHierarchy> => {
    const config = {params, ...axiosConfig}
    const response = await api.get<PlantHierarchy>(
      `upm/plants/hierarchy/permitted?permissionFilter=${permissionFilter}`,
      config
    )
    return response.data
  }

export const getUpmHierarchySummary =
  (api: AxiosInstance) =>
  async (hierarchyIds: string[], axiosConfig?: AxiosRequestConfig): Promise<PlantHierarchyNode[]> => {
    const response = await api.post<PlantHierarchyNode[]>(
      'upm/plants/hierarchy/summary',
      hierarchyIds,
      axiosConfig
    )
    return response.data
  }
